import { ValidationError } from './apiError';
import { isLeft } from 'fp-ts/lib/Either';
import { RawApi } from '.';
import { driverStandings, DriverStandings, raceGrid, RaceGrid, TeamStandings, teamStandings } from './validators/motorsport';

export interface MotorsportAPI {
  fetchMotorsportRaceGrid: (tourId: string, eventId: string) => Promise<RaceGrid>;
  fetchMotorsportDriverStandings: (tourId: string) => Promise<DriverStandings>;
  fetchMotorsportTeamStandings: (tourId: string) => Promise<TeamStandings>;
}

export class MotorsportApi extends RawApi implements MotorsportAPI {
  public async fetchMotorsportRaceGrid(
    tourId: string,
    eventId: string,
  ): Promise<RaceGrid> {
    const response = await this.fetchScoresApi(`/motorsport/v4/${tourId}/grid/${eventId}`);
    const jsonResponse: unknown = await response.json();
    const grid = raceGrid.decode(jsonResponse);

    if (isLeft(grid)) {
      throw new ValidationError('API Response validation failed', 400, grid);
    }

    return grid.right;
  }

  public async fetchMotorsportDriverStandings(tourId: string): Promise<DriverStandings> {
    const response = await this.fetchScoresApi(`/motorsport/v4/${tourId}/driverstandings`);
    const jsonResponse: unknown = await response.json();
    const standings = driverStandings.decode(jsonResponse);

    if (isLeft(standings)) {
      throw new ValidationError('API Response validation failed', 400, standings);
    }

    return standings.right;
  }

  public async fetchMotorsportTeamStandings(tourId: string): Promise<TeamStandings> {
    const response = await this.fetchScoresApi(`/motorsport/v4/${tourId}/teamstandings`);
    const jsonResponse: unknown = await response.json();
    const standings = teamStandings.decode(jsonResponse);

    if (isLeft(standings)) {
      throw new ValidationError('API Response validation failed', 400, standings);
    }

    return standings.right;
  }
}
